import { useEffect } from 'react';

type DefaultCbt = (e: MouseEvent | TouchEvent) => void;
export function useOnClickOutside<T extends Node, CbT extends DefaultCbt>(ref: T, cb: CbT): void {
  useEffect(() => {
    const listener = (event: MouseEvent | TouchEvent) => {
      // Do nothing if clicking ref's element or descendent elements
      if (!ref || ref?.contains?.(event.target as Node)) {
        return;
      }
      cb(event);
    };
    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);
    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, cb]);
}
